import request from "@/utils/request";
// 获取本小组的业务微信列表
export function getGroupSellerWechats() {
  return request({
    url: '/group/sellerwechats',
    method: 'get'
  })
}

// 修改业务号归属员工
export function updateGroupSellerWechatUser(data) {
  return request({
    url: '/group/updatesellerwechatuser',
    method: 'post',
    data
  })
}

export function changeOrderUser(data) {
  return request({
    url: '/group/changeorderuser',
    method: 'post',
    data
  })
}

export function getGroupRefunds(params) {
  return request({
    url: '/group/refunds',
    method: 'get',
    params
  })
}

export function auditGroupRefund(data) {
  return request({
    url: '/group/auditrefund',
    method: 'post',
    data
  })
}


export function getGroupPreOrders(prams) {
  return request({
    url: '/group/getgrouppreorder',
    method: 'get',
    params:prams
  })
}



export function newGroupDailyReport(data){
    return request({
        url: '/group/newgroupdailyreport',
        method: 'post',
        data
    })
}

export function getGroupNewClientsList(data){
  return request({
    url: '/group/getgroupnewclientslist',
    method: 'post',
    data
  })
}

export function getGroupPreOrderList(data){
  return request({
    url: '/group/getgrouppreorderlist',
    method: 'post',
    data
  })
}

export function getGroupReturnVisitList(data){
  return request({
    url: '/group/getgroupreturnvisitlist',
    method: 'post',
    data
  })
}
export function getGroupSalesData(data) {
  return request({
    url: '/group/getgroupsalesdata',
    method: 'post',
    data
  })
}


export function getGroupMembersTodolist(data) {
  return request({
    url: '/group/getgroupmemberstodolist',
    method: 'post',
    data
  })
}
export function getGroupMemberDailyReport(data) {
  return request({
    url: '/group/getgroupmembersdailyreport',
    method: 'post',
    data
  })
}


export function getGroupClientCalender(params) {
  return request({
    url: '/group/getgroupclientcalendar',
    method: 'get',
    params:params
  })
}


export function updataCourseAssignment(data){
  return request({
    url: '/group/updatacourseassignment',
    method: 'post',
    data
  })
}


export function getGroupCourse(){
  return request({
    url: '/group/getgroupcourses',
    method: 'get',
  })
}

export function getGroupClients(params) {
  return request({
    url: '/group/getgroupclients',
    method: 'get',
    params
  })
}

export function getGroupMembers() {
  return request({
    url: '/group/getgroupmembers',
    method: 'get',
  })
}

export function setGroupTarget(data) {
  return request({
    url: '/group/setgrouptarget',
    method: 'get',
    params:data
  })
}


export function setSellerTarget(data) {
  return request({
    url: '/user/setsellertarget',
    method: 'get',
    params:data
  })
}

export function getGroupInfo(data) {
  return request({
    url: '/group/getgroupinfo',
    method: 'get',
    params:data
  })
}


export function getGroupOrders(data) {
  return request({
    url: '/group/getgrouporders',
    method: 'get',
    params:data
  })
}

export function ReturnVisitPreOrder(params) {
  return request({
    url: '/group/returnvisitpreorder',
    method: 'get',
    params
  })
}
